import { createSelector } from '@ngrx/store';

import type { CellarState, NdtFileManagerState } from '@app/store/reducers';
import { getFileManagerState } from '@app/store/reducers';
import type { CellarData } from '@app/types/cellar-data.type';

/**
 * General Cellar State selector
 */
export const getCellarState: any = createSelector(
  getFileManagerState,
  (state: NdtFileManagerState) => !!state && state.cellar,
);

export const getWineByKey: any = (key: string) =>
  createSelector(getCellarState, (state: CellarState) => !!state && state[key]);

export const triggerWhenNotExists: any = (key: string) =>
  createSelector(getWineByKey(key), (wine: CellarData) => !wine);
